import React from "react";

/**
 * @component StopwatchIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <StopwatchIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const StopwatchIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      data-testid="StopwatchIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M8 1.333a6.667 6.667 0 110 13.333A6.667 6.667 0 018 1.333zm0 1.334a5.333 5.333 0 100 10.666A5.333 5.333 0 008 2.667zM8.666 4v4.667H7.333V4h1.333zm4.39-3.886l2.83 2.829-.943.942-2.829-2.828.943-.943z"
        clipRule="evenodd"
      />
    </svg>
  )
);
StopwatchIcon.displayName = "StopwatchIcon";
export default StopwatchIcon;
